import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { ProgressProps, progressStyles, useProgress } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-progress',
  template: `<div [ngClass]="progress">
    <span class="progress-bar" #barRef></span>
  </div>`,
})
export class ProgressComponent implements AfterViewInit {
  @ViewChild('barRef') barRef: ElementRef;

  _orientationValue: ProgressProps['orientation'] = 'horizontal';
  /**
   * CSS del componente
   */
  @Input() css: ProgressProps['css'];

  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'resize', () => {
      this.setStyle(this.orientation, this.value);
    });
  }

  _value: ProgressProps['value'];

  @Input() get value() {
    return this._value;
  }

  set value(value: ProgressProps['value']) {
    this._value = value;
    if (value) this.setStyle(this.orientation, value);
  }

  _orientation: ProgressProps['orientation'];

  @Input() get orientation() {
    return this._orientation;
  }

  set orientation(value: ProgressProps['orientation']) {
    this._orientation = value;
    //if (this.value && value) this.setStyle(value, this.value);
  }

  get progress(): string[] {
    return [
      progressStyles({
        orientation: this.orientation,
        css: this.css,
      }).className,
    ];
  }

  setStyle(orientation: ProgressProps['orientation'], value: ProgressProps['value']) {
    if (this.barRef && this.barRef.nativeElement) useProgress(orientation, value, this.barRef?.nativeElement);
  }

  ngAfterViewInit() {
    this.setStyle(this.orientation, this.value);
  }
}
